var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-admin",
    },
    [
      _vm.templatesView ? _c("courseware-admin-templates") : _vm._e(),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-admin-view-widget",
            name: "sidebar-views",
          },
        },
        [_c("courseware-admin-view-widget")],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-admin-action-widget",
            name: "sidebar-views",
          },
        },
        [_c("courseware-admin-action-widget")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }